import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'NeonSwap | The most versatile DEX on NEON EVM',
  description: 'Smooth, fast, frictionless swaps, yields, and farms on NEON L1.',
  image: 'https://neonswap.io/files/images/ogImage.jpg',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `${t('Home')} | ${t('NeonSwap')}`,
      }
    case '/swap':
      return {
        title: `${t('Exchange')} | ${t('NeonSwap')}`,
      }
    case '/add':
      return {
        title: `${t('Add Liquidity')} | ${t('NeonSwap')}`,
      }
    case '/remove':
      return {
        title: `${t('Remove Liquidity')} | ${t('NeonSwap')}`,
      }
    case '/liquidity':
      return {
        title: `${t('Liquidity')} | ${t('NeonSwap')}`,
      }
    case '/limit-order':
      return {
        title: `${t('Limit Order')} | ${t('NeonSwap')}`,
      }
    case '/find':
      return {
        title: `${t('Import Pool')} | ${t('NeonSwap')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('NeonSwap')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('NeonSwap')}`,
      }
    case '/info':
      return {
        title: `${t('Overview')} | ${t('NeonSwap Info & Analytics')}`,
        description: 'View statistics for NeonSwap exchange.',
      }
    case '/info/pools':
      return {
        title: `${t('Pools')} | ${t('NeonSwap Info & Analytics')}`,
        description: 'View statistics for NeonSwap exchange.',
      }
    case '/info/tokens':
      return {
        title: `${t('Pools')} | ${t('NeonSwap Info & Analytics')}`,
        description: 'View statistics for NeonSwap exchange.',
      }
    default:
      return null
  }
}
